import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  residenceFormRules,
  sharedFormValidator,
} from '@credit-acceptance/shareable-utilities';

export function residenceFieldValidator(): ValidatorFn {
  return (controlToValidate: AbstractControl): ValidationErrors | null => {
    const controlName = Object.entries(
      controlToValidate.parent?.controls ?? {}
    ).find(([_, control]) => control === controlToValidate)?.[0];

    if (controlName) {
      const { errors } = sharedFormValidator(
        'residenceFormRules',
        controlName as keyof typeof residenceFormRules,
        controlToValidate.value
      );
      if (errors && errors.length) {
        const errorObject: Record<string, string> = {};
        for (const err of errors) {
          errorObject[err.rule] = err.message;
        }
        return errorObject;
      } else {
        return null;
      }
    }
    return null;
  };
}
